import React from 'react';
import EllipsisCellRenderer from './EllipsisCellRenderer';

export const RowIndexCellRenderer = ({ rowIndex }) => <EllipsisCellRenderer value={rowIndex + 1} lines={1} />;

RowIndexCellRenderer.propTypes = {
    ...EllipsisCellRenderer.propTypes,
};
